import { RAWSTER_SUPPORT_EMAIL } from "./RawsterLayout";
import { BrandedHeading, RawsterBrand } from "./RawsterBrand";

export function RawsterTerms() {
  return (
    <main className="rawster-main rawster-doc">
      <header className="rawster-doc-header">
        <BrandedHeading as="h1">Terms of Use</BrandedHeading>
        <RawsterBrand className="rawster-brand-subtitle" />
        <p className="rawster-doc-updated">Last updated: June 1, 2026</p>
      </header>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Agreement to Terms</BrandedHeading>
        <p>
          These Terms of Use (&quot;Terms&quot;) govern your access to and use of the
          Rawster mobile application and related services (the &quot;App&quot;). By
          downloading, accessing, or using the App, you agree to these Terms and our
          Privacy Policy. If you do not agree, do not use the App.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Eligibility</BrandedHeading>
        <p>
          You must be at least 13 years old (or the minimum age required in your
          jurisdiction) to use Rawster. If you are under 18, you represent that you have
          permission from a parent or guardian. The App is for personal, non commercial
          use unless otherwise agreed in writing.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Description of Service</BrandedHeading>
        <p>
          Rawster provides tools for connection tracking (including on-device Radar),
          relationship reflection, Pulses, questions, optional Rawster AI (Pro), and self
          awareness. Features may change over time. We do not provide medical,
          psychological, legal, or professional relationship advice. Content in the App,
          including Rawster AI output, is for informational and personal reflection
          purposes only.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Your Account and Content</BrandedHeading>
        <p>
          You may sign in with Apple or a phone number. You are responsible for
          maintaining the security of your account and for all activity under your
          account. You retain ownership of content you submit. You grant us a limited
          license to host, store, and process your content solely to operate and improve
          the App, as described in our Privacy Policy.
        </p>
        <p>
          <strong>Rawster AI.</strong> Rawster AI is optional and requires Rawster Pro.
          Before your first AI request, you must accept in-app consent that data may be
          sent to OpenAI. You are responsible for what you type or send to Rawster AI. AI
          responses may be inaccurate; use your own judgment.
        </p>
        <p>
          You agree not to upload unlawful, harassing, defamatory, or infringing content,
          or to use the App to harm others or violate any applicable law.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Subscriptions and Payments</BrandedHeading>
        <p>
          Some features require Rawster Pro, an auto-renewable subscription through the
          Apple App Store. Pricing and billing terms are displayed at purchase. Payments
          and refunds are handled by Apple according to Apple&apos;s policies. Subscription
          status may be verified through RevenueCat. Cancel in iOS Settings → Apple ID →
          Subscriptions. Access continues until the end of the current billing period after
          cancellation.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Intellectual Property</BrandedHeading>
        <p>
          The App, including its design, software, trademarks, and documentation, is
          owned by us or our licensors and protected by intellectual property laws. You may
          not copy, modify, distribute, reverse engineer, or create derivative works
          except as expressly permitted by law or these Terms.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Disclaimer of Warranties</BrandedHeading>
        <p>
          THE APP IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; WITHOUT
          WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING IMPLIED
          WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON
          INFRINGEMENT. WE DO NOT WARRANT THAT THE APP WILL BE UNINTERRUPTED, ERROR FREE,
          OR SECURE.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Limitation of Liability</BrandedHeading>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE AND OUR AFFILIATES SHALL NOT BE
          LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
          DAMAGES, OR ANY LOSS OF PROFITS, DATA, OR GOODWILL, ARISING FROM YOUR USE OF
          THE APP, INCLUDING RELIANCE ON RAWSTER AI OUTPUT. OUR TOTAL LIABILITY FOR ANY
          CLAIM RELATING TO THE APP SHALL NOT EXCEED THE GREATER OF THE AMOUNT YOU PAID
          US IN THE TWELVE MONTHS BEFORE THE CLAIM OR ONE HUNDRED U.S. DOLLARS (USD
          $100).
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Termination</BrandedHeading>
        <p>
          You may stop using the App at any time and may delete your account in Settings
          or by contacting support. We may suspend or terminate access if you violate
          these Terms or if required for legal or security reasons. Provisions that by
          their nature should survive termination will survive.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Governing Law</BrandedHeading>
        <p>
          These Terms are governed by the laws of the United States and the State of
          Delaware, without regard to conflict of law principles, except where mandatory
          consumer protection laws in your country provide otherwise.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Changes to Terms</BrandedHeading>
        <p>
          We may modify these Terms at any time. Material changes will be indicated by
          updating the date above. Your continued use after changes become effective
          constitutes acceptance where permitted by law.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Contact</BrandedHeading>
        <p>
          Questions about these Terms:{" "}
          <a href={`mailto:${RAWSTER_SUPPORT_EMAIL}`}>{RAWSTER_SUPPORT_EMAIL}</a>
        </p>
      </section>
    </main>
  );
}
